import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { JobDescription } from "../../models/domains/pbm/Beneficiary/job-description";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { JobDescriptionParser } from "../parsers/pbm/job-description/job-description.parser";

@Injectable()
export class JobDescriptionRepository {
  constructor(private remoteGatewayFactory: RemoteGatewayFactory, private jobDescriptionParser: JobDescriptionParser) {}

  public async getJobDescription(fiscalNumber: string) {
    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.getWithHeaders(new BackendUrl("/api/company/jobs/" + fiscalNumber), headers);
      return this.jobDescriptionParser.parse(data);
    } catch (httpErrorResponse) {
      return await Promise.reject(httpErrorResponse.error.Data.ErrorMessage);
    }
  }

  public async createJobDescription(jobDescription: JobDescription, fiscalNumber: string) {
    const headers = { "Content-Type": "application/json" };

    const body = JSON.stringify({
      Key: jobDescription.getKey(),
      Title: jobDescription.getTitle(),
      Enabled: jobDescription.getEnabled(),
      FiscalNumber: fiscalNumber,
    });

    try {
      const response = await this.remoteGatewayFactory.createDefaultRemoteGateway().postWithHeaders(new BackendUrl("/api/company/jobs"), body, headers);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async editJobDescription(jobDescription: JobDescription, fiscalNumber: string) {
    const headers = { "Content-Type": "application/json" };

    const body = {
      Key: jobDescription.getKey(),
      Title: jobDescription.getTitle(),
      Enabled: jobDescription.getEnabled(),
      FiscalNumber: fiscalNumber,
    };

    try {
      const response = await this.remoteGatewayFactory.createDefaultRemoteGateway().putWithHeaders(new BackendUrl("/api/company/jobs"), body, headers);

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async deleteJobDescription(jobDescriptionkey: string, fiscalNumber: string) {
    const headers = { "Content-Type": "application/json" };

    try {
      const response = await this.remoteGatewayFactory
        .createDefaultRemoteGateway()
        .deleteWithHeaders(new BackendUrl(`/api/company/jobs/${jobDescriptionkey}/${fiscalNumber}`), headers);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
